@import 'src/styles/common/_colors.scss';

.searchFilter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    > p {
        margin: 0;
        margin-right: 10px;
    }
    .search-filter-select {
        div[class*="-control"] {
            div[class*="-ValueContainer"] {
                div[class*="-Input"] {
                    background-color: $white !important;
                    color: $gray-variant-3 !important;
                    input {
                        background-color: $white !important;
                        color: $gray-variant-3 !important;
                    }
                }
            } 
        }
        div[class*="-menu"] {
            z-index: 999;
        }
    }
    .inputSearchContainer {
        display: flex;
        align-items: center;
        background-color: $white;
        border-radius: 5px;
        input {
            border-radius: 5px;
            margin-right: 5px;
            border: none;
            padding: 3px 5px;
            &:active, &:focus, &:focus-visible {
                border: none !important;
                outline: none;
            }
            
        }
        .inputClearSearch {
            width: 20px;
            height: 20px;
            background-color: $white;
            color: $black;
            display: flex;
            font-weight: 600;
            border-radius: 5px;
            cursor: pointer;
            justify-content: center;
            &:hover {
                background-color: $smoke-white; 
            }
            span {
                font-size: 15px;
                position: relative;
                top: 4px;
                right: 3px;
                &::before {
                    color: $gray;
                }
            }
        }
    }
    .searchFilterButton {
        min-width: 35px;
    }
}